export enum AnalyticsDestination {
    GTM = 'gtm',
    POSTHOG = 'posthog'
}
